import React from "react";
import { ReactComponent as InfoIcon } from "../../../Assets/ActionIcons/InfoIcon.svg";
import { ReactComponent as CloseCircle } from "../../../Assets/ActionIcons/CloseCircle.svg";


type AlertType = "warning" | "error";

interface AlertCardProps {
  type: AlertType;
  message: string;
  title?: string;
  className?: string;
}

const alertStyles: Record<
  AlertType,
  {
    bg: string;
    border: string;
    text: string;
    icon: React.ReactNode;
    title: string;
  }
> = {
  warning: {
    bg: "bg-yellow-50",
    border: "border-yellow-400",
    text: "text-gray-800",
    icon: <InfoIcon className="h-6 w-6 text-yellow-600" />,
    title: "Warning"
  },
  error: {
    bg: "bg-red-50",
    border: "border-red-500",
    text: "text-gray-800",
    icon: <CloseCircle className="h-6 w-6 text-red-600" />,
    title: "Error"
  }
};

const AlertCard: React.FC<AlertCardProps> = ({ type, message, title, className = "" }) => {
  const styles = alertStyles[type];

  return (
    <div
      className={`border p-4 flex items-start gap-3 mt-4 ${styles.bg} ${styles.border} ${className}`}
    >
      <div className="shrink-0">{styles.icon}</div>
      <div className="flex-1 min-w-0">
        <p className={`text-md font-semibold mb-1 ${styles.text}`}>{title || styles.title}</p>
        <p className={`text-sm ${styles.text} break-words whitespace-pre-line`}>{message}</p>
      </div>
    </div>
  );
};

export default AlertCard;
